import { IconProps } from "../../utils/global-types/global-types";

const ElectricIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M13.926 7.169a.33.33 0 0 0-.29-.169H9.269L10 1.406a.336.336 0 0 0-.614-.217l-5.31 9.303A.333.333 0 0 0 4.36 11h4.302l-.58 5.602a.335.335 0 0 0 .617.205l5.223-9.302a.33.33 0 0 0 .004-.336"
      ></path>
    </svg>
  );
};

export default ElectricIcon;
